var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isColor)?_c('img',{style:({ width: _vm.logoWidth }),attrs:{"alt":"gritify logo","src":"/gritify_logo_color.svg"}}):_c('img',{style:({ width: _vm.logoWidth }),attrs:{"alt":"gritify logo dark","src":"/gritify_logo_on_dark.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }